import {attr, define, Record} from "type-r";

@define
class StreetModel extends Record {
    @attr name: string;
    @attr slug: string;
    @attr users_count?: number;
}

export default StreetModel;



// WEBPACK FOOTER //
// ./src/models/StreetModel.ts